import { DdsImage as Image, FOURCC_DXT1, FOURCC_DXT3, FOURCC_DXT5, FOURCC_ATI2 } from './image';
import isDds from './isformat';

export default {
  Image,
  FOURCC_DXT1,
  FOURCC_DXT3,
  FOURCC_DXT5,
  FOURCC_ATI2,
  isDds,
};
